import Util from '../../Common/Util';

// 오더 메모(발주자 입력) → HTML. 저장된 <br>(취소사유 등)과 SoojooController 가 붙이는 붉은 강조만 태그로 남긴다
const memoHtml = (v) => Util.escapeHtml(v)
    .replace(/&lt;\/?br\s*\/?&gt;/gi, '<br>')
    .replace(/&lt;b style=&#39;color:red&#39;&gt;/g, "<b style='color:red'>")
    .replace(/&lt;\/b&gt;/g, '</b>');

export default class Soojoo {
    constructor() {
        this.selectedNum = null; // 선택한 오더번호
        this.orderMap = {}; // map {오더번호 -> 오더배열}
        this.orders = [];// 오더번호 목록
        this.sigMap = {}; // map {오더번호 -> 상태서명} — 서버가 이걸 보고 성격이 바뀐 카드만 다시 내린다
        this.interval = 2000; // 새로고침 간격(ms)
    }

    /**
     * 초기화
     */
    initialize(){
        const self = this;
        // 알림의 [매칭종료]로 들어오면 그 오더가 수주됐는지 본다 (#page-data)
        this.searchOrderNum = JSON.parse(document.getElementById('page-data')?.textContent || '{}').searchOrderNum;

        // 새 수주 안내 띠 · 하단 요약바 칸 (예전 href=javascript:·onclick)
        $('.to-top').on('click', (e) => { e.preventDefault(); this.onClickNewAlert(); });
        $('.sj-foot__cell[data-replace]').on('click', function () { location.replace(this.dataset.replace); });
        $('.sj-foot__cell[data-href]').on('click', function () { document.location.href = this.dataset.href; });

        // 수주목록을 가져온다.
        this.getNewOrderList(true);
        setInterval(function(){
            self.getNewOrderList(false);
        },this.interval);
    }


    /**
     * 수주목록 가져오기
     * @param isFirst 최초여부
     */
    getNewOrderList(isFirst){
        const self = this;
        $.ajax({
            url: "/m/ajax/soojoo/list",
            type: "POST",
            data: {
                "list": this.orders, //기존의 오더번호 목록들
                "sig":  this.sigMap, // 오더번호 → 상태서명. 바뀐 카드는 changed:1 로 다시 온다
                'search': this.searchOrderNum, // 검색할 오더번호 (알림에서 매칭종료 버튼 누르고 들어오는경우, 그오더가 수주되었는지 여부확인)
            },
            success: function (res) {
                const list = (res && res.list) || [];
                const gone = (res && res.gone) || [];

                // 목록에서 빠진 카드(취소·남이 수주 뒤 30초 경과) — 걷어낸다
                gone.forEach((num) => {
                    $(`#ea_table${num}`).remove();
                    delete self.orderMap[num];
                    delete self.sigMap[num];
                    self.orders = self.orders.filter((n) => n != num);
                });

                let added = false;
                $.each(list, function (key, order) {
                    const ordernum = order['num'];
                    self.orderMap[ordernum] = order;
                    self.sigMap[ordernum]   = order.sig;

                    if( order.changed ){
                        // 보여준 카드의 성격이 바뀜(3분대기 → 어플전환, 남이 수주 등) — 그 자리에서 교체.
                        // isFirst=true 로 그려 남이 잡았으면 커버가 씌워진다 (이미 봤던 카드라 시도 유예가 필요 없다)
                        const $new = $(self.makeSoojooBox(order, true)).addClass('ea_tables_new');
                        $(`#ea_table${ordernum}`).replaceWith($new);
                    }else{
                        self.orders.push(ordernum);
                        const html = self.makeSoojooBox(order, isFirst);
                        if( isFirst) { // 최초에는 아랫쪽으로 나열하기
                            $("#soojoo-list").append(html);
                        }else{ // 이후에는 윗쪽에 집어넣기
                            $("#soojoo-list").prepend(html);
                            $(".ea_tables").eq(0).addClass("ea_tables_new");// 노란색 테두리를 넣어서 새로운 오더임을 표시
                            added = true;
                        }
                    }
                    self.bindCard(ordernum);
                });

                if( added ) self.showNewAlert();

                const empty = $("#soojoo-list .ea_tables").length == 0;
                $("#soojoo-empty").toggle(empty);
                $("#soojoo-list").toggle(!empty);
            }
        });
    }

    /** 카드 안 버튼(승인·거절·전달·멈춤) 바인딩 — 터치와 클릭 모두 반응하게 */
    bindCard(ordernum){
        $j.Common.Util.bindTouchClick($(`#ea_table${ordernum} .matchBtn`), function(e){
            const num = $(this).data('num');
            switch ($(this).data('action')) {
                case 'get':     $j.p.getQuery(num);     break;
                case 'reject':  $j.p.rejectQuery(num);  break;
                case 'forward': $j.p.forwardQuery(num); break;
                case 'stop':    $j.p.stopQuery(num);    break;
            }
        });
    }

    /**
     * 수주 테이블 한개를 보여준다.
     * @param order
     * @param isFirst 최초진입 여부 (false=모니터링 중 폴링으로 새로 뜬 카드)
     */
    makeSoojooBox(order, isFirst){
        const esc = (v) => $('<div>').text(Util.nvl(v)).html();
        let act='';     // 오른쪽 버튼칸
        let note='';    // 지정발주·3분대기 안내 (카드 맨 아래 띠)
        let warn='';    // 악덕알리미 경고
        let cover='';

        // 우측 수주버튼 표시여부(1:버튼표시, 2:내가수주, 3:남이수주)
        if( [1,3].includes(order['btnStatus']) ) {
            act = `<button type="button" class="matchBtn is-primary" data-action="get" data-num="${order.num}">승인</button>`;
            if (order['order_type'] == '95') {// 지정발주일때는 거절,전달 버튼 표시
                act += `<button type="button" class="matchBtn is-danger" data-action="reject" data-num="${order.num}">거절</button>`
                     + `<button type="button" class="matchBtn is-danger" data-action="forward" data-num="${order.num}">전달</button>`;
            } else if (order['order_type'] == '0' && order['btnStatus'] == 1) {// 어플발주는 내 목록에서만 치운다
                act += `<button type="button" class="matchBtn is-danger" data-action="reject" data-num="${order.num}">거절</button>`;
            }
        }else if(order['btnStatus']==2){
            act = `<span class="sj-mine" onum="${order.num}">내가<br>수주함</span>`;
        }

        // 지정발주인지 3분대기인지
        if(order['order_type']=='95'){
            let msg = '', stop = '';
            if(order['direct_wait_mode']==1){
                // 멈춤은 예전처럼 안내 띠의 오른쪽 옆에 둔다 (승인 칸이 아니라 "3분 후 자동 어플발주" 문구 곁)
                stop = `<button type="button" class="matchBtn is-danger sj-stop" data-action="stop" data-num="${order.num}">멈춤</button>`;
                msg = `<b>${esc(order.bal_owner_name)}</b> 님의 어플 발주입니다.<br>3분 후 자동 어플발주 예정`;
            }else{
                msg = `<b>${esc(order.bal_owner_name)}</b> 님이 회원님을 지정하여 발주한 오더입니다.`;
            }
            // 안내는 왼쪽 섹션(주소·메모 아래)에 넣는다 — 카드 아래 띠로 두면 버튼칸보다 카드가 길어진다
            note = `<div class="sj-note"><div class="sj-note__text">${msg} ${order.optionStr || ''}</div>${stop}</div>`;
        }
        // 악덕알리미
        if( order['isBadCompany'] == 1 || order['isBadCompany'] == 2 ) {
            const where = order['isBadCompany'] == 1 ? '거래처 번호' : '현장번호';
            warn = `<div class="sj-warn"><b>주의</b> 이 오더의 ${where}는 다른 회원이 악덕업체로 등록한 업체입니다.`
                 + `<span class="sj-warn-sub">수주를 결정하기 전 먼저 [등록]페이지의 악덕업체를 참조하세요</span></div>`;
        }

        if(order['btnStatus']==2){// 내가 수주
            cover = `<div class="cover"><span>내가 수주함</span></div>`;
        }
        else if(order['btnStatus']==3){// 남이 수주
            // 모니터링 중(폴링)에 새로 뜬 카드는 커버를 씌우지 않아 밑의 승인 버튼을 누를 수 있게 한다.
            // (방금 수주되어 5초간 노출 유예중인 카드 — 회원이 '잡을 기회도 없이 뺏겼다'고 오해하지 않도록 시도 기회를 준다.
            //  단 order_status=6 확정 상태라 실제 승인 시도는 '이미 다른 기사가 수주 중'으로 막힌다.)
            if( isFirst ) cover = `<div class="cover"><span>이미 수주함</span></div>`;
        }

        const howtopay = $j.F.Order.Biz.howtopayStr(order['pay_method'], order['sign_days']);
        const wt  = dayjs(order['work_time']);
        const dow = '일월화수목금토'[wt.day()];
        // 차수 '(-3 차)' → '-3차' 칩으로. 어플발주가 아니면 서버가 빈 값을 준다
        const lvl = String(order.order_level_st || '').replace(/[()\s]/g, '');
        // 메모는 발주자가 쓴 글이라 이스케이프하고, 줄바꿈(<br>)과 서버가 붙인 강조(보험 정산 안내)만 되살린다
        const memo = memoHtml(order.request_note);
        const opt  = esc(order.car_option);
        const nofee = order['is_fee']!='1';

        return `
<div id="ea_table${order.num}" class="ea_tables sj-card${order.isTaken ? ' is-taken' : ''}">
    <div class="sj-card__head">
        <div class="sj-when">
            <b class="sj-when__date">${order.wdd}</b><span class="sj-when__dow">(${dow})</span>
            <b class="sj-when__time">${wt.format('HH:mm')}</b>
            <span class="sj-chip">${esc(order.Work_dayH_show)}</span>
        </div>
        <div class="sj-price">${order.PP}<small>P</small></div>
    </div>
    <div class="sj-card__body">
        <div class="sj-main">
            <div class="sj-addr">${esc(order.showAddress)}</div>
            ${warn}
            ${(lvl || memo) ? `<div class="sj-memo">${lvl ? `<span class="sj-lvl">${lvl}</span>` : ''}${memo}</div>` : ''}
            ${(opt || nofee) ? `<div class="sj-opt">${opt ? `<span class="sj-tag">옵션</span><span>${opt}</span>` : ''}${nofee ? `<span class="sj-nofee">수수료없음</span>` : ''}</div>` : ''}
            ${note}
        </div>
        <div class="sj-side">
            <div class="sj-side__pay">${howtopay}</div>
            ${order.work_content ? `<div class="sj-side__work">${esc(order.work_content)}</div>` : ''}
            <div class="sj-side__car">${esc(order.sCartype_show)}</div>
        </div>
        <div class="sj-act">${act}</div>
    </div>
    ${cover}
</div>
    `;

    }

    /**
     * 수주 승인창
     * @param ordernum
     */
    getQuery(ordernum) {
        const self = this;
        Util.swalert(['이 오더를 승인할까요?','question'], ()=>{
            self.getOrder(ordernum);
        },['승인','취소']);
    }

    /**
     * 오더 수주 진행
     * @param ordernum
     */
    getOrder(ordernum){
        const self = this;
        $('.black').show();// 로딩이미지 띄운다.
        var adr = `/m/ajax/order/${ordernum}/soojoo`;
        $.ajax({type:"POST", url:adr , success:function(data){
            var sta = data.status;
            $('.black').hide();
            self.showGetResult(sta, ordernum, data.msix_nday);
        }});
    }
    /**
     * 오더수주 결과 표시
     * @param n : 상태번호
     * @param order_num : 오더번호
     * @param msixNday : -6차 소진(-9)일 때 매칭에 쓰였던 -6차의 일차 (없으면 null)
     */
    showGetResult(n, order_num, msixNday){
        // 음수:에러번호(0:다른기사가이미수주,-1:회원없음,-2:캐시부족,-3:차량미보유,-4:환원건 있음, -5:중복수주,-6:발주제한,-7:수주제한,-9:-6차소진,-10:발주개수부족)
        if( n==1){
            this.openAfterBS(order_num);
            return;
        }
        else if( n==0){
            Util.swalert("이미 다른 기사가 수주 중 입니다");
        }else if( n== -1){
            Util.swalert("로그인 정보가 없거나 없는회원입니다.\n다시 로그인해 주세요");
        }else if( n == -3){
            Util.swalert("이 오더를 수주할 차량을 미보유 중 입니다.\n이 오더의 미터와 옵션을 확인해 주세요");
        }else if( n == -4){
            Util.swalert("환원건이 있어 수주가 제한되었습니다.");
        }else if( n == -5){
            // 형제 분기는 전부 swalert 인데 여기만 빨간 25px 카드였다. 무게는 tone 으로 남긴다.
            $j.Ui.Dialog.open({
                tone:  'danger',
                title: '중복 수주 불가',
                desc:  '장비불러에 등록된 보유기종이\n이미 수주한 상태입니다.',
            });
        }else if( n == -6){//수주제한
            Util.swalert("이발주자가 발주한 오더를 수주하지 않기로 발주제한된 오더입니다");
        }else if( n == -7){//발주제한
            Util.swalert("발주자가 회원님을 수주제한하여 본오더를 수주할 수 없습니다");
        }else if( n == -9){//-6차 소진 (일차는 ver3 만 내려온다)
            const msix = msixNday ? `-6차 ${msixNday}일차` : '보유하신 -6차';
            Util.swalert(`${msix}를 이미 사용하여\n이 오더는 수주하실 수 없습니다`);
        }else if( n == -10){//발주개수 부족
            Util.swalert("차수를 적용해 알림받은 오더입니다.\n발주개수가 부족하여\n이 오더는 수주할 수 없습니다");
        }else if( n== -100) {
            Util.swalert("본 오더를 수주할 포인트가 부족합니다\n포인트를 확인해 주세요");
        }else{
            Util.swalert("처리중 에러가 발생하였습니다.");
        }

        $('.black').hide();// 로딩이미지 숨긴다.
    }

    /**
     * 수주완료 BottomSheet 표시 (별도 페이지 이동 없이)
     * @param ordernum
     */
    openAfterBS(ordernum){
        $('.black').show();
        $.ajax({
            type: "POST",
            url: "/m/ajax/soojoo/after",
            data: { ordernum },
            dataType: "JSON",
            success: (d) => {
                $('.black').hide();
                if (!d || !d.result) {
                    Util.swalert((d && d.msg) || "수주완료 정보를 불러오지 못했습니다");
                    document.location.replace('/m/diary/list');
                    return;
                }
                $j.Ui.BS.open({ target: this.makeAfterTarget(d) });
            },
            error: () => {
                $('.black').hide();
                document.location.replace('/m/diary/list');
            },
        });
    }

    /**
     * 수주완료 BS 의 ad-hoc target (BS.open 의 target 규약: init/destroy)
     * @param d 서버 응답(afterData)
     */
    makeAfterTarget(d){
        const esc = (s) => $('<div>').text(s == null ? '' : s).html();
        const price = Number(d.car_price || 0).toLocaleString();

        // 출금신청 자동취소 안내는 BS 가 아니라 일지이동 후 일지페이지에서 모달로 노출한다.
        const cashCancel = Number(d.cash_cancel_amount) > 0;

        const html = `
<div class="sa">
    <div class="sa-grabber"></div>
    <div class="sa-body">
        <div class="sa-hero">
            <div class="sa-check"><i class="fas fa-check"></i></div>
            <h1 class="sa-title">수주확정!</h1>
        </div>

        <div class="sa-card">
            <div class="sa-row"><span class="sa-label">현장</span><span class="sa-value">${esc(d.site_address)}</span></div>
            <div class="sa-row"><span class="sa-label">일시</span><span class="sa-value">${esc(d.work_label)}</span></div>
            <div class="sa-row"><span class="sa-label">장비</span><span class="sa-value">${esc(d.car_label)}</span></div>
            <div class="sa-row sa-row--price"><span class="sa-label">대금</span><span class="sa-value sa-price">${price}원</span></div>
        </div>

        <div class="sa-howto">
            <p class="sa-howto__title">아래 순서대로 진행해주세요.</p>
            <div class="sa-steps">
                <div class="sa-step">
                    <div class="sa-step__rail"><span class="sa-step__no">1</span></div>
                    <div class="sa-step__txt"><div class="sa-step__main">일지에서 발주자 전화</div></div>
                </div>
                <div class="sa-step sa-step--dash">
                    <div class="sa-step__rail"><span class="sa-step__no">2</span></div>
                    <div class="sa-step__txt">
                        <div class="sa-step__main">통화 후 일지 새로고침</div>
                        <div class="sa-step__sub">현장번호·상세주소 자동 표시</div>
                    </div>
                </div>
                <div class="sa-step sa-step--q">
                    <div class="sa-step__rail"><span class="sa-step__no">?</span></div>
                    <div class="sa-step__txt">
                        <div class="sa-step__main">주소 미입력 시</div>
                        <div class="sa-step__sub">발주자에게 문자로 요청하세요</div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="sa-btnbar">
        <button type="button" class="sa-btn">일지이동</button>
    </div>
</div>`;

        return {
            init() {
                const $cont = $('#' + this.id);
                $cont.closest('.bottomsheet-popup').addClass('soojoo-after-bs');
                $cont.html(html);
                $cont.off('click.sa').on('click.sa', '.sa-btn', () => {
                    // 캐시부족 출금신청 자동취소 시, 일지페이지에서 모달로 안내하도록 플래그 전달
                    const url = cashCancel ? d.move_url + '&cashcancel=1' : d.move_url;
                    document.location.replace(url);
                });
            },
            destroy() {
                $('.bottomsheet-popup').removeClass('soojoo-after-bs');
            },
        };
    }

    /** 거절 확인창 — 껍데기·슬롯은 공용 $j.Ui.Dialog (구 .sjr 전용 마크업+scss) */
    rejectQuery(ordernum){
        this.selectedNum = ordernum;
        const order = this.orderMap[ordernum] || {};
        if (order['order_type'] == '0') { this.rejectAppQuery(order); return; }
        $j.Ui.Dialog.open({
            tone:    'danger',
            title:   '오더 거절',
            desc:    '지정받은 오더를 거절합니다',
            rows:    [{ k: '현장',     v: Util.nvl(order.showAddress) },
                      { k: '거절하면', v: '장비불러 회원 전체에게 어플발주로 전환됩니다' }],
            confirm: '오더 거절',
            cancel:  '닫기',
            // 막을 때는 창을 닫지 않고 그 자리에서 이유를 말한다 (구 #eaNotice 슬롯 자리)
            validate:  () => this.rejectBlockReason(),
            onConfirm: () => this.reject(),
        });
    }

    /**
     * 거절을 막아야 하는 이유 — 없으면 빈 문자열.
     * 작업시간 20분 전부터는 어플발주로 돌릴 시간이 없다.
     */
    rejectBlockReason(){
        const order = this.orderMap[this.selectedNum];
        const left = parseInt((new Date(order['work_time']).getTime() - Date.now()) / 1000 / 60);
        return left < 20
            ? '작업시간 20분 전입니다. 작업시간까지 20분 이상 남은 오더만 일반 발주로 전환할 수 있습니다.'
            : '';
    }

    /**
     * 어플발주 거절 확인창 — 지정 거절과 달리 오더는 그대로고 내 수주목록에서만 빠진다.
     * 오더수정으로 다시 매칭돼도 다시 뜨지 않고 매칭알림도 오지 않는다 (OrderRejectService).
     */
    rejectAppQuery(order){
        $j.Ui.Dialog.open({
            tone:    'danger',
            title:   '오더 거절',
            desc:    '이 오더를 수주목록에서 지웁니다',
            rows:    [{ k: '현장', v: Util.nvl(order.showAddress) }],
            confirm: '오더 거절',
            cancel:  '닫기',
            onConfirm: () => this.rejectApp(order.num),
        });
    }

    /** 어플발주 거절 실행 — 새로고침 없이 그 카드만 걷어낸다 (폴링의 gone 처리와 같은 정리) */
    rejectApp(num){
        const self = this;
        $.ajax({
            type: 'POST',
            url: `/m/ajax/order/${num}/reject`,
            dataType: 'JSON',
            success: (res) => {
                if (!res || !res.result) { Util.swalert((res && res.message) || '거절하지 못했습니다.'); return; }
                $(`#ea_table${num}`).remove();
                delete self.orderMap[num];
                delete self.sigMap[num];
                self.orders = self.orders.filter((n) => n != num);
                const empty = $("#soojoo-list .ea_tables").length == 0;
                $("#soojoo-empty").toggle(empty);
                $("#soojoo-list").toggle(!empty);
                $j.Ui.Toast.show('거절했어요', { type: 'success' });
            },
        });
    }

    /** 오더 거절 실행 (확인창이 이미 막을 이유를 확인했다) */
    reject(){
        $j.Common.Util.loadingOverlay(true);
        $.ajax({
            type: 'POST',
            url: `/m/ajax/order/${this.selectedNum}/reject`,
            dataType: 'JSON',
            success: () => { location.reload(); },
        });
    }


    // 전달 확인창
    forwardQuery(ordernum){
        this.selectedNum = ordernum;
        const self = this;
        $j.Ui.BS.open({
            target: '$j.F.ModalPhone',
            data: {
                $p: { from: '수주', why: '지정', ordernum },
                onApply: ($r) => {
                    const order = self.orderMap[self.selectedNum];
                    if (!order.$r) order.$r = {};
                    Object.assign(order.$r, $r);
                    if (!order.$p) order.$p = {};
                    order.$p['why'] = '지정';

                    switch (Util.int(order.$r['order_type'])) {
                        case 91: Util.swalert('본인 및 소속자에게는 전달할수 없습니다.'); break;
                        case 94: Util.swalert('회원에게만 전달할수 있습니다.'); break;
                        case 95: $j.F.Order.Biz.baljooToOther(order); break;
                    }
                },
            },
        });
    }


    /**
     * 3분대기 -> 지정오더 확인창 (구 confirm — 거절 확인창과 같은 $j.Ui.Dialog)
     * @param ordernum
     */
    stopQuery(ordernum){
        const order = this.orderMap[ordernum] || {};
        $j.Ui.Dialog.open({
            tone:    'warn',
            title:   '자동 어플발주 멈춤',
            desc:    '이 오더를 일반 지정 오더로 전환합니다',
            rows:    [{ k: '현장',     v: Util.nvl(order.showAddress) },
                      { k: '멈추면',   v: '3분 후 자동 어플발주가 취소됩니다' }],
            confirm: '멈춤',
            cancel:  '닫기',
            onConfirm: () => this.stop(ordernum),
        });
    }

    /** 3분대기 멈춤 실행 — 지정 오더로 바뀌었으면 목록을 다시 읽는다 */
    stop(ordernum){
        $.ajax({
            type: "POST",
            url: `/m/ajax/order/${ordernum}/stop`,
            success: (data) => {
                if( !data.result ) {
                    Util.swalert(data.message || '멈추지 못했습니다. 이미 어플발주로 전환됐을 수 있습니다.');
                    return;
                }
                Util.swalert(['일반 지정 오더로 변경되었습니다', 'success'], () => location.replace('/m/soojoo'));
            },
            error: () => Util.swalert('처리중 에러가 발생하였습니다.'),
        });
    }

    // 새로운 오더가 나타났음을 알리는 상자 표시
    showNewAlert(){
        // 하단 요약바 바로 위에 띄운다. 바 높이는 값 길이(두 줄로 접힘)와 글자크기(body zoom)에 따라
        // 57~93px 사이로 변해서 CSS 고정값으로는 맞출 수 없다 → 실측해서 얹는다.
        // offsetHeight 는 CSS px(줌 미반영)이라 bottom 과 단위가 같다. getBoundingClientRect 는 뷰포트 px 라 안 맞는다.
        const $foot = $('.sj-foot');
        if ($foot.length) $(".to-top").css('bottom', $foot[0].offsetHeight + 'px'); // margin:10px 이 더해져 간격 10px
        $(".to-top").show();
        $(".to-top").animate({opacity: 1 }, 'slow');
    }
    // 그 상자를 클릭시
    onClickNewAlert() {
        $('html, body').animate({scrollTop: 0 }, 'slow');
        $(".to-top").animate({opacity: 0 }, 'slow');
    }
}